import { Center } from '@web/components/atoms/Layout'
import { Body2 } from '@web/components/atoms/Typography'
import { DonationFormStep, useDonationFormContext } from '@web/components/page-components/DonationForm'
import { PageButton } from '@web/components/page-components/PageButton'
import { DonationFormStepProps } from './utils'
import { useShallow } from 'zustand/react/shallow'
import { usePaymentStore } from 'apps/fe-donation/libs/hooks/usePaymentStore'

const DonationFormErrorStep = ({ styles }: DonationFormStepProps) => {
  const setStep = useDonationFormContext(useShallow(({ actions }) => actions.setStep))
  const paymentError = usePaymentStore((state) => state.paymentError)
  return (
    <Center flexDirection="column" gap="16px">
      <Body2>
        {paymentError || 'Payment failed.'} Please update your details or use another method. For assistance, please
        contact us.
      </Body2>
      <PageButton
        id="back-to-step-1"
        buttonText="Try again"
        name="Primary"
        bgColorOverride={styles?.accentColor}
        onClick={() => setStep(DonationFormStep.Step1)}
        width="100%"
      />
    </Center>
  )
}

export default DonationFormErrorStep
